import React from 'react';
import Skeleton from "react-loading-skeleton";
import styles from "../MenuFeatures.module.css";

function MenuFeaturesSkeleton() {
    return(
        <>
            <h2 className={styles.title}>
                <Skeleton count={1} style={{width: "30%"}} />
            </h2>
            <div className={styles.list_items}>
                {Array.apply(0, Array(3)).map((n, i) => (
                    <div className={styles.wrapp_item} key={i} style={{lineHeight: 1}}> 
                        <Skeleton height={259} style={{width:"100%"}}/>
                    </div>   
                ))}    
            </div>  
        </>      
    );
}
export default MenuFeaturesSkeleton;